import { render } from "./index.vue?vue&type=template&id=bc1e53e4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=bc1e53e4&lang=less&scoped=true"

import exportComponent from "/root/workspace/service-web_SY5C/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc1e53e4"]])

export default __exports__